import { selectFormById } from "@overmap-ai/core"
import { createFileRoute, notFound } from "@tanstack/react-router"

import { appStore } from "../../../../../../../../store"
import { formSettingsFieldsViewStaticData } from "../../../../../../../../views/FormSettingsFieldsView/constants"
import { FormSettingsFieldsView } from "../../../../../../../../views/FormSettingsFieldsView/FormSettingsFieldsView"

export const Route = createFileRoute("/_loggedIn/$organizationId/_map/_layout/settings/forms/$formId/fields")({
	component: FormSettingsFieldsView,
	staticData: formSettingsFieldsViewStaticData,
	loader: ({ params }) => {
		const form = selectFormById(params.formId)(appStore.getState())
		if (!form) throw notFound()
	},
})
